// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

::ng-deep .form-group {
  text-align: left;
}

::ng-deep input, ::ng-deep select {
  height: 38px;
  border-radius: var(--vl-border-radius);
}

ngx-stripe-card {
  padding: 16px 8px;
  display: block;
}

ion-item {
  --padding-start: 0;
}

.saved-card {
  --background: white !important;
  margin-bottom: 16px;
  --border: none;
  margin: 0 -15px;
  margin-top: 24px;
  --padding-start: 20px;
}
.saved-card ion-avatar {
  height: 53px;
  width: 50px;
  align-items: center;
  display: flex;
}
.saved-card ion-icon, .saved-card vl-icon {
  position: absolute;
  right: 16px;
  z-index: 100;
  top: 16px;
}
.saved-card ::ng-deep vl-icon svg {
  stroke: var(--vl-black-font);
}
.saved-card.card-view {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}

ngx-stripe-card-group {
  display: block;
  margin-top: 32px;
}
ngx-stripe-card-group ngx-stripe-card-number, ngx-stripe-card-group ngx-stripe-card-cvc, ngx-stripe-card-group ngx-stripe-card-expiry, ngx-stripe-card-group input {
  border-radius: 10px;
  padding: 8px;
  border: 1px solid #DDDEE3;
  background-color: #ffffff;
  height: 46px;
}
ngx-stripe-card-group input {
  border: 1px solid #dddee3;
  box-shadow: none;
  -webkit-appearance: none !important;
  color: #32325D;
  font-weight: 500;
  line-height: 32px;
  font-family: Inter UI, Open Sans, Segoe UI, sans-serif;
  font-size: 1rem;
  -webkit-font-smoothing: antialiased;
}
ngx-stripe-card-group .cvc {
  width: 25%;
  text-align: left;
  padding-right: 4px;
}
ngx-stripe-card-group .expired {
  width: calc(35% - 2px);
  text-align: left;
  padding-left: 4px;
  padding-right: 4px;
}
ngx-stripe-card-group .zip {
  padding-left: 4px;
  width: 40%;
  text-align: left;
}
ngx-stripe-card-group .card-number {
  margin-bottom: 16px;
  text-align: left;
}
ngx-stripe-card-group ngx-stripe-card-number {
  display: block;
  width: 100%;
}
ngx-stripe-card-group ngx-stripe-card-cvc {
  display: block;
  width: 100%;
}
ngx-stripe-card-group ngx-stripe-card-expiry {
  display: block;
  width: 100%;
}
ngx-stripe-card-group input {
  display: block;
  width: 100%;
}

.save-for-future {
  padding-left: 4px;
}
.save-for-future ion-checkbox {
  margin-right: 10px;
  --border-color: #DDDEE3;
  --border-width: 1px;
}
.save-for-future ion-label {
  margin: 0;
}

form label, form ion-label {
  margin-bottom: 4.5px !important;
  color: #262627 !important;
  transform: none !important;
  font-size: 14px !important;
  max-height: 16px;
}

.custom-btn-block {
  margin-bottom: 36px !important;
}
.custom-btn-block ion-item {
  margin-bottom: 16px;
}

vl-pay-with-paypal {
  flex: 1 1 auto;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: 16px;
}

.name {
  margin-top: 16px;
}
.name label {
  width: 100%;
  text-align: left;
}
.name input {
  border-radius: 10px;
  padding: 8px;
  border: 1px solid #DDDEE3;
  background-color: #ffffff;
  height: 46px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/app/modules/payment/components/add-new-credit-card/add-new-credit-card.component.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AAvDA;EACE,gBAAA;AA0DF;;AAvDA;EACE,YAAA;EACA,sCAAA;AA0DF;;AAvDA;EACE,iBAAA;EACA,cAAA;AA0DF;;AAvDA;EACE,kBAAA;AA0DF;;AAtDA;EACE,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAyDF;AAvDE;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;AAyDJ;AAtDE;EACE,kBAAA;EACA,WD5Ba;EC6Bb,YAAA;EACA,SAAA;AAwDJ;AApDI;EACE,4BAAA;AAsDN;AAlDE;EACE,4BAAA;EACA,6BAAA;AAoDJ;;AA/CA;EACE,cAAA;EACA,gBAAA;AAkDF;AA/CE;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AAiDJ;AA9CE;EACE,yBAAA;EACA,gBAAA;EACA,mCAAA;EAEA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,sDAAA;EACA,eAAA;EACA,mCAAA;AA+CJ;AA5CE;EACE,UAAA;EACA,gBAAA;EACA,kBAAA;AA8CJ;AA3CE;EACE,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AA6CJ;AA1CE;EACE,iBAAA;EACA,UAAA;EACA,gBAAA;AA4CJ;AAxCE;EACE,mBAAA;EACA,gBAAA;AA0CJ;AAvCE;EACE,cAAA;EACA,WAAA;AAyCJ;AAtCE;EACE,cAAA;EAEA,WAAA;AAuCJ;AApCE;EACE,cAAA;EAEA,WAAA;AAqCJ;AAlCE;EACE,cAAA;EAEA,WAAA;AAmCJ;;AA9BA;EACE,iBAAA;AAiCF;AA/BE;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;AAiCJ;AA9BE;EACE,SAAA;AAgCJ;;AA3BE;EACE,+BAAA;EACA,yBAAA;EACA,0BAAA;EACA,0BAAA;EACA,gBAAA;AA8BJ;;AA1BA;EACE,8BAAA;AA6BF;AA3BE;EACE,mBAAA;AA6BJ;;AAzBA;EACE,cAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AA4BF;;AAzBA;EACE,gBAAA;AA4BF;AA1BE;EACE,WAAA;EACA,gBAAA;AA4BJ;AAzBE;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;AA2BJ","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n\n::ng-deep .form-group {\n  text-align: left;\n}\n\n::ng-deep input, ::ng-deep select {\n  height: 38px;\n  border-radius: var(--vl-border-radius);\n}\n\nngx-stripe-card {\n  padding: 16px 8px;\n  display: block;\n}\n\nion-item {\n  --padding-start: 0;\n}\n\n\n.saved-card {\n  --background: white !important;\n  margin-bottom: 16px;\n  --border: none;\n  margin: 0 -15px;\n  margin-top: 24px;\n  --padding-start: 20px;\n\n  ion-avatar {\n    height: 53px;\n    width: 50px;\n    align-items: center;\n    display: flex;\n  }\n\n  ion-icon, vl-icon {\n    position: absolute;\n    right: $global-padding;\n    z-index: 100;\n    top: 16px;\n  }\n\n  ::ng-deep vl-icon {\n    svg {\n      stroke: var(--vl-black-font);\n    }\n  }\n\n  &.card-view {\n    border-top-left-radius: 25px;\n    border-top-right-radius: 25px;\n  }\n}\n\n\nngx-stripe-card-group {\n  display: block;\n  margin-top: 32px;\n\n\n  ngx-stripe-card-number, ngx-stripe-card-cvc, ngx-stripe-card-expiry, input {\n    border-radius: 10px;\n    padding: 8px;\n    border: 1px solid #DDDEE3;\n    background-color: #ffffff;\n    height: 46px;\n  }\n\n  input {\n    border: 1px solid #dddee3;\n    box-shadow: none;\n    -webkit-appearance: none !important;\n\n    color: #32325D;\n    font-weight: 500;\n    line-height: 32px;\n    font-family: Inter UI, Open Sans, Segoe UI, sans-serif;\n    font-size: 1rem;\n    -webkit-font-smoothing: antialiased;\n  }\n\n  .cvc {\n    width: calc(25%);\n    text-align: left;\n    padding-right: 4px;\n  }\n\n  .expired {\n    width: calc(35% - 2px);\n    text-align: left;\n    padding-left: 4px;\n    padding-right: 4px;\n  }\n\n  .zip {\n    padding-left: 4px;\n    width: calc(40%);\n    text-align: left;\n  }\n\n\n  .card-number {\n    margin-bottom: 16px;\n    text-align: left;\n  }\n\n  ngx-stripe-card-number {\n    display: block;\n    width: calc(100%);\n  }\n\n  ngx-stripe-card-cvc {\n    display: block;\n    //width: calc(25%);\n    width: calc(100%);\n  }\n\n  ngx-stripe-card-expiry {\n    display: block;\n    //width: calc(35% - 2px);\n    width: calc(100%);\n  }\n\n  input {\n    display: block;\n    //width: calc(40%);\n    width: calc(100%);\n\n  }\n}\n\n.save-for-future {\n  padding-left: 4px;\n\n  ion-checkbox {\n    margin-right: 10px;\n    --border-color: #DDDEE3;\n    --border-width: 1px;\n  }\n\n  ion-label {\n    margin: 0;\n  }\n}\n\nform {\n  label, ion-label {\n    margin-bottom: 4.5px !important;\n    color: #262627 !important;\n    transform: none !important;\n    font-size: 14px !important;\n    max-height: 16px;\n  }\n}\n\n.custom-btn-block {\n  margin-bottom: 36px !important;\n\n  ion-item {\n    margin-bottom: 16px;\n  }\n}\n\nvl-pay-with-paypal {\n  flex: 1 1 auto;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  margin-bottom: 16px;\n}\n\n.name {\n  margin-top: 16px;\n\n  label {\n    width: 100%;\n    text-align: left;\n  }\n\n  input {\n    border-radius: 10px;\n    padding: 8px;\n    border: 1px solid #DDDEE3;\n    background-color: #ffffff;\n    height: 46px;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
